import { FONT_FAMILY } from "./utils/font";
import { getTextWidth } from "./utils/platform";

function registerInput(input) {
    const maxFontSize = parseInt(input.dataset.maxFontSize, 10);
    const minFontSize = parseInt(input.dataset.minFontSize, 10);
    let currentFontSize = maxFontSize;
    input.addEventListener("input", () => {
        if (input.value) {
            const font = `${currentFontSize}px ${FONT_FAMILY}`;
            if (getTextWidth(input.value, font) > input.clientWidth && currentFontSize > minFontSize) {
                while (getTextWidth(input.value, font) > input.clientWidth && currentFontSize > minFontSize) {
                    currentFontSize -= 0.2;
                }
            } else if (getTextWidth(input.value, font) <= input.clientWidth && currentFontSize < maxFontSize) {
                while (getTextWidth(input.value, font) <= input.clientWidth && currentFontSize < maxFontSize) {
                    currentFontSize += 0.2;
                }
            }
        } else {
            currentFontSize = maxFontSize;
        }
        input.style.fontSize = currentFontSize + "px";
    });
}

function init() {
    var inputs = document.querySelectorAll("input[data-elastic-font-size]");
    Array.from(inputs).forEach(registerInput);
}

window.addEventListener("DOMContentLoaded", init);

export {
    registerInput
};
